<template lang="pug">
  SspLayout(area="core")
    .col-md-6
      .panel.panel-default
        .panel-body
          .container-fluid
            .form-group
              .row
                label.col-sm-4 Organization
                .col-sm-8
                  .ic-control
                    OrganizationSelect(v-model="selectedOrganizationId")
            .form-group
              .row
                label.col-sm-4 User
                .col-sm-8
                  .ic-control
                    UserSelectFromOrganization(:organizationId="selectedOrganizationId" v-model="selectedUserId" ref="userSelect")
            .form-group
              .row
                .col-sm-8.col-sm-offset-4
                  SspActionButton(:disabled="!isValid" :spinning="running" :text="`Run as ${selectedUserObject.username || ''}`" @onClick='()=>runAs(selectedUserObject.username)')
    .col-md-6
      .panel.panel-default
        .panel-body
          .container-fluid
            .form-group
              .row
                label.col-sm-4 User name
                .col-sm-8
                  input.form-control.user-name-input(v-model="username" placeholder="User name")
            .form-group
              .row
                .col-sm-8.col-sm-offset-4
                  SspActionButton(:disabled="!username" :spinning="running" :text="`Run as ${username || ''}`" @onClick="()=>runAs(username)")
      .panel.panel-default
        .panel-body
          .container-fluid
            .form-group
              label.col-sm-4 Run as recent
              .col-sm-8
                div(v-for="name in recentName" @click="runAs(name)")
                  button.btn.btn-link {{name}}


</template>
<script>
import Vue from 'vue'
import OrganizationSelect from '@/components/ssp/OrganizationSelect'
import UserSelectFromOrganization from '@/components/ssp/UserSelectFromOrganization'
import Security from '@/service/apis/Security'
import AuthService from '@/service/AuthService'
import LocalStore from '@/service/LocalStore'

const recentNamesStore = LocalStore.createList('runas:recentUsernames', 5)
const recentOrganizationStore = LocalStore.createItem('runas:recentOrganization', null)

export default {
  data: () => ({
    running: false,
    selectedOrganizationId: null,
    selectedUserId: null,
    selectedUserObject: {},
    username: null,
    recentName: [],
  }),
  created() {
    this.recentName = recentNamesStore.get()
    this.selectedOrganizationId = Number(recentOrganizationStore.get())
  },
  methods: {
    runAs(username) {
      this.running = true
      return Security.runAs(username)
        .then(() => {
          AuthService.refreshContext().then(() => {
            Vue.nextTick(() => {
              this.$router.push({ name: 'userPreferences' })
            })
          })
          recentNamesStore.push(username)
          recentOrganizationStore.set(this.selectedOrganizationId)
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.running = false
        })
    }
  },
  watch: {
    selectedUserId() {
      if (this.selectedUserId) {
        this.selectedUserObject = this.$refs.userSelect.getSelectedUser()
      } else {
        this.selectedUserObject = {}
      }
    }
  },
  computed: {
    isValid() {
      return this.selectedUserId
    }
  },
  components: {
    OrganizationSelect,
    UserSelectFromOrganization
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/security/RunAs.vue